import Dexie, { EntityTable } from 'dexie';
import { useLiveQuery } from 'dexie-react-hooks';
import { useCallback, useEffect, useState } from 'react';
import { EventData, STATUS, Status } from 'react-joyride';

interface TourSeen {
    key: string;
    read: boolean;
}

export interface ToursDatabase extends Dexie {
    tourSeen: EntityTable<TourSeen, 'key'>;
}

export function createToursDatabase() {
    const db = new Dexie('TourDatabase') as ToursDatabase;
    db.version(1).stores({
        tourSeen: 'key',
    });
    return db;
}

const db = createToursDatabase();

// Function to reset the tours database - used by DevTools
export function resetToursDatabase() {
    return db.tourSeen.clear();
}

export function useOnboardingTours(tourKey: string) {
    const seenData = useLiveQuery(() => db.tourSeen.where('key').equals('style-timeline').toArray());
    const [run, setRun] = useState(false);

    useEffect(() => {
        if (seenData === undefined) {
            return;
        }

        const seen = seenData.length > 0 && seenData[0].read === true;
        if (!seen) {
            setRun(true);
        }
    }, [seenData]);

    const handleJoyrideCallback = useCallback(
        (data: EventData) => {
            const statuses = [STATUS.FINISHED, STATUS.SKIPPED] as Status[];
            if (statuses.includes(data.status)) {
                setRun(false);
                db.tourSeen.put({ key: tourKey, read: true });
            }
        },
        [tourKey]
    );

    const startTour = useCallback(() => {
        setRun(true);
    }, []);

    return { run, startTour, handleJoyrideCallback };
}
